import { publicRoute } from "@utils/router";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export const BasePage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const token = Cookies.get("token");
  const redirect = Cookies.get("redirect");
  const isLoggedIn = token && redirect === "/home/dashboard" ? true : false;
  useEffect(() => {
    if (
      (publicRoute.includes(location.pathname) || location.pathname === "/") &&
      isLoggedIn
    ) {
      return navigate("/home/dashboard", { replace: true });
    }

    if (
      (!publicRoute.includes(location.pathname) || location.pathname === "/") &&
      !isLoggedIn
    ) {
      return navigate("/auth/login", { replace: true });
    }
  }, [navigate, location]);
  return (
    <div>
      <Outlet />
    </div>
  );
};
